import $ from 'zepto';
// var template = require('../common/template.js');
import template from '../common/template.js';

$.fn.textSlider = function(set) {
    var config = $.extend({
        direction: 'top',
        speed: 2000,
        wait: 1000,
        child: 'ul',
        line: 1,
        per: 1,
        html: ''
    }, set);
    return this.each(function() {
        $.fn.textSlider.scllor($(this), config);
    });
};

$.fn.textSlider.scllor = function($this, config) {
    var wrap = $this.find(config.child).eq(0);
    if (config.html) {
        wrap.html(config.html);
    } else {
        if(config.data && wrap.html()) {
            var _html = template.build(wrap.html())(config.data);
            wrap.html(_html);
        }
    }

    var timer;
    var sub = wrap.children();
    if (sub.length === 0) {
        return;
    }
    var auto = true;
    config.sub = sub.get(0).tagName.toLocaleString();
    var liHight, upHeight, liWigth, leftWidth;
    var ing = false;
    var scrollUp = function() {
        liHight = 0;
        upHeight = 0;
        for (var i = 0; i < config.line; i++) {
            liHight = wrap.children().eq(i * config.per).outerHeight(true);
            upHeight = upHeight - liHight;
        }
        ing = true;
        wrap.animate({
            marginTop: upHeight
        }, config.speed, function() {
            wrap.find(config.sub).slice(0, config.per * config.line).appendTo(wrap);
            wrap.css({
                marginTop: 0
            });
            ing = false;
            auto && (timer = setTimeout(scrollUp, config.wait));
        });
    };

    var scrollLeft = function() {
        liWigth = 0;
        leftWidth = 0;
        for (var i = 0; i < config.line; i++) {
            liWigth = wrap.children().eq(i * config.per).outerWidth(true);
            leftWidth = leftWidth - liWigth;
        }
        ing = true;
        wrap.animate({
            marginLeft: leftWidth
        }, config.speed, function() {
            wrap.find(config.sub).slice(0, config.per * config.line).appendTo(wrap);
            wrap.css({
                marginLeft: 0
            });
            ing = false;
            auto && (timer = setTimeout(scrollLeft, config.wait));
        });
    };

    var fn;
    switch (config.direction) {
        case 'left':
            fn = scrollLeft;
            break;
        default:
            fn = scrollUp;
    }
    var autoPlay = function() {
        auto = true;
        if (!ing) {
            timer = setTimeout(fn, config.wait);
        }
    };
    var autoStop = function() {
        auto = false;
        clearTimeout(timer);
    };
    if (!('ontouchstart' in window)) {
        // $this.hover(autoStop, autoPlay);
        $this.on('mouseenter', autoStop).on('mouseleave', autoPlay);
    }
    fn();
};

module.exports = function(opt, data, direction) {
    if(typeof opt === 'string') {
        opt = {wrap: opt, data: data, direction: direction};
    }
    $(opt.wrap).eq(0).textSlider(opt);
}



// WEBPACK FOOTER //
// ./src/tools/textSlider.js